import { Component } from 'react';
import cx from 'classnames';
import Button from './ui/button';
import styles from '../styles/modal.scss';
import { showScroll, hideScroll } from '../utils';
import { CDN_CLRSAVE_URL } from '../constants';

interface Props {
  onDismiss?: any;
  onUnmount?: any;
  title?: string | JSX.Element;
  titleImage?: string;
  showFooter?: boolean;
  showFooterWithoutButton?: boolean;
  onSumbit?: any;
  width?: string;
  maxWidth?: string;
  padding?: number | string;
  paddingTop?: number | string;
  headerPad?: number;
  hideHeader?: boolean;
  fullScreen?: boolean;
  showClose?: boolean;
  marginBottom?: string;
  footerPopup?: boolean;
  disableClose?: boolean;
  scrollBodyX?: boolean;
  subHeadingMessage?: string;
  handleBack?: any;
  disableBackButton?: boolean;
  bottomBorderRemove?: boolean;
}
interface State {
  isModalOpen?: boolean;
}

export default class Modal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }
  public dismiss(e: any) {
    this.setState({ isModalOpen: false }, () => {
      showScroll();
      if (this.props.onDismiss && e) {
        this.props.onDismiss();
      }
    });
  }
  public componentDidMount() {
    setTimeout(() => {
      this.setState({ isModalOpen: true });
      hideScroll();
    }, 0);
  }
  public componentWillUnmount() {
    showScroll();
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }

  public render() {
    const { isModalOpen } = this.state;
    const {
      children,
      title,
      titleImage,
      showFooter,
      showFooterWithoutButton,
      onSumbit,
      width,
      maxWidth,
      padding,
      paddingTop,
      headerPad,
      hideHeader,
      fullScreen,
      showClose,
      marginBottom,
      footerPopup,
      disableClose,
      scrollBodyX,
      subHeadingMessage,
      handleBack,
      disableBackButton = true,
      bottomBorderRemove = false,
    } = this.props;

    return (
      <div>
        <div
          className={cx(
            styles['save-modal'],
            {
              [styles['full-screen']]: fullScreen,
              [styles['sm-open']]: isModalOpen,
              [styles['footer-popup']]: footerPopup,
            },
            'save-modal'
          )}
        >
          <div className={styles['sm-content']}>
            {hideHeader ? null : (
              <div
                className={cx(
                  'sm-header lil-flex lil-items-center',
                  styles['sm-header']
                )}
                style={bottomBorderRemove ? { borderBottom: 'none' } : {}}
              >
                {!disableBackButton ? (
                  <span className="lil-pr-3" onClick={handleBack}>
                    <img
                      className={cx(styles['back'])}
                      src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1573624151_leftarrow.svg`}
                      alt="circle"
                    />
                  </span>
                ) : null}
                {subHeadingMessage ? (
                  <div className={cx('mb5', 'mt5')}>
                    <div className={cx('pb5', 'text--sm')} title="title">
                      {title || 'Complete Your Investment'}
                    </div>
                    <h2 className={cx(styles['title'], 'pb10')} title="title">
                      <b>{subHeadingMessage}</b>
                    </h2>
                  </div>
                ) : (
                  <h2 className={styles.title} title="title">
                    {title ||
                      (titleImage && <img src={titleImage} />) ||
                      'Complete Your Investment'}
                  </h2>
                )}
                {disableClose ? null : (
                  <span onClick={e => this.dismiss(e)} className="sm-close">
                    &#10005;
                  </span>
                )}
              </div>
            )}
            <div
              className={cx(
                styles['sm-component'],
                scrollBodyX ? styles['scroll-x'] : ''
              )}
            >
              {hideHeader && showClose ? (
                <span onClick={e => this.dismiss(e)} className="sm-close">
                  &#10005;
                </span>
              ) : null}
              {children}
            </div>
            {showFooter || showFooterWithoutButton ? (
              <div className={styles['sm-footer']}>
                {showFooter ? (
                  <Button
                    label="Next"
                    type="primary"
                    float="fr"
                    disabled={false}
                    loadingLabel={'Loading...'}
                    className={cx('s-btn', styles['modal-primary'])}
                    onClick={e => {
                      if (onSumbit) {
                        onSumbit(e);
                      }
                    }}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
        <div className={styles['modal-wrapper']} />
        <style jsx>{`
          .save-modal {
            max-width: ${(maxWidth ? maxWidth : width) || '630px'};
            padding: ${paddingTop || '15px'} ${padding || '10px'};
            min-height: 200px;
          }

          .sm-header {
            /* padding: ${headerPad ? `0 ${headerPad}px` : '0 40px'}; */
            margin-bottom: ${marginBottom || '15px'};
          }

          @media screen and (max-width: 768px) {
            .save-modal {
              max-width: 100%;
              top: 50%;
            }
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/modal.tsx